// import "./App.css";
// import "./styles/Variables.scss";

import { useEffect } from "react";
import { useNavigate, Routes, Route, useLocation } from "react-router-dom"
import { Helmet } from "react-helmet";
import { Tooltip } from 'react-tooltip'

import TransitionWrapper from "./components/TransitionWrapper.jsx";
// PAGES
import Main from "./pages/Main.tsx";
import UnderConstruction from "./pages/UnderConstruction";
import NotFound from "./pages/NotFound.tsx";
import Meta from "./pages/Meta";

// OUTLET VIEWS
import Home from "./views/Home.jsx";
import Explore from "./views/Explore";
import Challenge from "./views/Challenge.tsx";
import Contests from "./views/Contests.tsx";
import Contest from "./views/Contest.tsx";
import Leaderboard from "./views/Leaderboard.tsx";
import CodeHouse from "./views/CodeHouse.tsx";
import Code from "./views/Code.tsx";
import Login from "./views/Login.tsx";
import ForgotPassword from "./views/ForgotPassword.tsx";
import Signup from "./views/Signup.tsx";
import Profile from "./views/Profile";
import Create from "./views/CreateContest.jsx";
import MyContests from "./views/MyContests.tsx";

import TermsAndConditions from "./views/TermsAndConditions.jsx";
import PrivacyPolicy from "./views/Privacy.jsx";

import Test from "./pages/Test.tsx";
import Edit from "./views/EditContest.jsx";
import PreviewContest from "./views/PreviewContest.tsx";

import pageTitles from "./utils/pageTitles.js";

import { refreshServersList } from "./scripts/axiosConfig.js";


// COMPONENTS
import { Slide, ToastContainer } from "react-toastify";

// STYLES
import "./styles/customToastStyle.scss"
import 'react-toastify/dist/ReactToastify.min.css';

import * as Sentry from "@sentry/react";

// ----------------------
// SENTRY INITIALIZATION
Sentry.init({
    dsn: "https://b84594d01ad811c545d79f03dc153201@o4509124117135360.ingest.de.sentry.io/4509124142366800",
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
      })
    ],
    // Session Replay
    replaysSessionSampleRate: 0.5, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
  

export const RedirectTo = ({ url }) => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(url);
    });

    return null;
};

export default function App() {
    const location = useLocation();
    const { pathname } = location;

    const title = pageTitles[pathname] || 'Codify';

    useEffect(() => {
        document.body.classList.add("dark");
        let serverUpdateInterval = null;
        refreshServersList();

        try {
            if (import.meta.env.PROD) {
                console.log("Setting interval for updating servers list.");
                serverUpdateInterval = setInterval(() => {
                    console.log("%c Refreshing servers list.", "color: #00ff00; font-weight: bold;");
                    refreshServersList();
                }, 60000); // 60 seconds
            }
            else {
                console.log("Not setting interval for updating servers list as we are in local.");
            }
        }
        catch (err) {
            console.error("Error setting interval for updating servers list.");
            console.log(err);
        }

        return () => {
            try {
                if (serverUpdateInterval) {
                    clearInterval(serverUpdateInterval);
                }
            }
            catch (err) {
                console.error("Error clearing interval for updating servers list.");
                console.log(err);
            }
        }

    }, []);

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>

            <Tooltip
                id="tt" 
                border="1px solid rgba(255, 255, 255, .25)"
            />

            <ToastContainer theme="dark" autoClose="10000" transition={Slide} stacked />
                {/* <TransitionGroup component={null}>
                    <CSSTransition key={location.key} classNames="fade" timeout={300}> */}
                    <TransitionWrapper key={location.key}>
                        <Routes location={location} key={location.pathname}>
                            <Route path="/" element={<Main />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/hero" element={<Home />} />
                                <Route path="/explore" element={ <Explore /> } />
                                <Route path="/contests" element={ <Contests /> } />
                                <Route path="/contests/:contestSlug" element={ <Contest /> } />

                                <Route path="/challenges" element={ <RedirectTo url={"/explore"} /> } />
                                <Route path="/challenges/:challengeID" element={ <Challenge /> } />
                                
                                <Route path="/profile" element={ <Profile /> }></Route>
                                <Route path="/profile/:username" element={ <Profile /> }></Route>
                                <Route path="/contests/create" element={ <Create /> }></Route>
                                <Route path="/contests/preview" element={ <PreviewContest /> }></Route>
                                <Route path="/contests/mine" element={ <MyContests /> }></Route>

                                {/* <Route path="/leaderboard" element={ <Leaderboard /> }></Route> */}
                                <Route path="/leaderboard/:contestSlug" element={ <Leaderboard /> }></Route>
                                
                                <Route path="/test" element={ <Test /> }></Route>
                                
                                <Route path="/meta" element={ <Meta /> }></Route>

                                <Route path="/terms" element={ <TermsAndConditions /> }></Route>
                                <Route path="/privacy" element={ <PrivacyPolicy /> }></Route>
                            </Route>
                            
                            <Route path="/contests/:contestSlug/code" element={ <CodeHouse /> }>
                                <Route path="/contests/:contestSlug/code" element={<Code />}></Route>
                            </Route>

                            <Route path="/login" element={ <Login /> }></Route>
                            <Route path="/signup" element={ <Signup /> }></Route>  
                            <Route path="/forgot-password" element={ <ForgotPassword /> }></Route>
                            
                            <Route path="/code" element={ <RedirectTo url={"/explore"} /> } />
                            <Route path="/code/:problemID" element={<CodeHouse />}>
                                <Route path="/code/:problemID" element={<Code />}></Route>
                            </Route>
                            
                            <Route path="/quiz/:quizID" element={<CodeHouse />}>
                                <Route path="/quiz/:quizID" element={<Code />}></Route>
                            </Route>

                            {/* <Route path="/dashboard" element={ <Pickle /> }></Route> */}
                            <Route path="/*" element={ <NotFound /> }></Route>
                        </Routes>
                    </TransitionWrapper>
                    {/* </CSSTransition>
                </TransitionGroup> */}
        </>
    );
}
